// extracted by mini-css-extract-plugin
module.exports = {"card":"AdminCard_card__1hfHF"};